import { useQuery } from '@tanstack/react-query';
import { fetchOpsSnapshot } from './api';

export const ADMIN_OPS_SNAPSHOT_QUERY_KEY = ['discord-activity-admin-ops-snapshot'] as const;

/**
 * Polls the Activity admin ops-snapshot endpoint via React Query — admin-only
 * source for the inline stuck-jobs strip on the consolidated view.
 *
 * Same cadence as the tester queue (5s refetch, background-on, retry-once)
 * so the stuck-jobs strip stays in lockstep with the queue around it. The
 * query key is exported so action handlers (release/terminate) can invalidate
 * it for an immediate refresh after a successful mutation rather than waiting
 * on the next polling tick.
 */
export function useAdminOpsSnapshot(accessToken: string | undefined) {
  return useQuery({
    queryKey: ADMIN_OPS_SNAPSHOT_QUERY_KEY,
    queryFn: () => fetchOpsSnapshot(accessToken!),
    enabled: Boolean(accessToken),
    refetchInterval: 5_000,
    refetchIntervalInBackground: true,
    retry: 1,
    staleTime: 0,
  });
}
